import { render, staticRenderFns } from "./ApplicationAdviserPrint.vue?vue&type=template&id=768becaa&scoped=true&"
import script from "./ApplicationAdviserPrint.vue?vue&type=script&lang=js&"
export * from "./ApplicationAdviserPrint.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationAdviserPrint.vue?vue&type=style&index=0&id=768becaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768becaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
